<section class="container py-5 mt-5 mb-2 mb-sm-3 mb-lg-4 mb-xxl-5">
  <h1 class="display-4 pb-3 pb-md-4 pb-lg-5">Despre GiftShare</h1>


  <div class="row justify-content-center align-items-center pt-xl-2 mb-lg-2 mb-xl-3 mb-xxl-4">
    <div class="col-lg-8 col-xl-7">
      <div class="d-block position-relative">
        <div class="bg-faded-danger rounded-5 position-absolute top-0 start-0 w-100 h-100" data-aos="zoom-in"
          data-aos-duration="600" data-aos-offset="250"></div>

        <svg-icon src="assets/images/illustrations/team.svg" class="d-block position-relative zindex-2 ms-auto"
          data-aos="fade-in" data-aos-duration="400" data-aos-offset="250"></svg-icon>

      </div>

      <div class="mt-5">
        <h2 class="h1 pb-md-2 pb-xl-3">Cum a inceput GiftShare</h2>
        <div class="pb-3 mb-3 mb-lg-4">
          <div class="card border-0 bg-secondary mb-4">
            <div class="card-body">
              <figure>
                <blockquote class="blockquote">
                  <p>Ce sa-i cumpar? Oare ce are nevoie? Se va bucura de ce i-am
                    ales?</p>
                </blockquote>
              </figure>
            </div>
          </div>

          <p> Cu siguranta fiecare dintre noi a intampinat, macar o data,
            dificultati in a alege cadoul potrivit pentru cineva drag. Si,
            foarte probabil, s-a confruntat cu situatia (foarte complicata) de
            a strange bani de la un grup mai mic sau mai mare de prieteni
            pentru o zi de nastere sau pentru o alta ocazie speciala, astfel
            incat cadoul sa fie mai consistent. Cand in sfarsit ”bugetul”
            total pentru cadou e definitivat, mai sunt de obicei doar cateva
            zile pentru a alege si cumpara cadoul si prea multe idei
            referitoare la ce ar putea fi acesta. Ceea ce inseamna multe batai
            de cap si timp pierdut. Suna cunoscut?</p>
          <p>De partea cealalta, fiecare dintre noi primeste anual, in diferite
            ocazii, cateva cadouri nefolositoare sau nu neaparat pe gustul
            nostru. In acelasi timp, este greu sa organizezi grupuri diferite
            de oameni (prieteni, familie, colegi de birou) sa stranga bani
            pentru un singur cadou, acel cadou pe care ti-l doresti nespus,
            dar care poate costa mai mult.</p>
          <p>Povestea de mai sus nu este deloc intamplatoare. Este povestea
            GiftShare, care a pornit tocmai pentru ca am trecut prin multe
            astfel de situatii de-a lungul timpului si pentru ca ne-am fi
            dorit sa avem acces la un serviciu prin care sa strangem bani
            pentru cadourile celor dragi si, in acelasi timp, sa primim mereu
            cadourile pe care ni le dorim.</p>
          <p>Si mai e ceva. Credem cu tarie ca cel mai mare cadou pe care ti-l
            poti face intr-un moment special din viata ta este sa daruiesti tu
            bucurie cuiva mai putin norocos sau sa faci o fapta buna in
            societate. De aceea, cu ajutorul nostru poti strange fonduri
            pentru a face lumea mai buna in jurul tau si poti inclusiv sa
            daruiesti fondurile stranse pentru cadoul tau cauzei sociale in
            care tu crezi.</p>
          <p>Un lucru e cert: cu GiftShare vei primi sau darui mereu cadoul
            perfect. Mai simplu si mai rapid ca oricand!</p>
          <p class="fs-4 fw-semibold fst-italic">Echipa GiftShare</p>
        </div>
      </div>
    </div>


  </div>


</section>
